import { ScheduleCharityAuctionPage } from '@/features/auctions/charity/schedule/ScheduleCharityAuctionPage';
import NextApp from '@/NextApp';
import dynamic from 'next/dynamic';

const AuthedGuard = dynamic(
  () => import('@/components/@next/AuthedGuard/AuthedGuard').then((m) => m.AuthedGuard),
  {
    ssr: false,
  },
);

export default function LiveStream() {
  return (
    <NextApp>
      <AuthedGuard
        membershipLevel="Charity"
        render={(user) => <ScheduleCharityAuctionPage user={user} />}
      />
    </NextApp>
  );
}
